<template>
  <div>
    <b-row>
      <b-col md="3">
        <validation-provider
          #default="{ errors }"
          name="Old Item Name"
          :vid="`${validationId}_old_item_name`"
          rules="required"
        >
          <b-form-group
            label="Old Item Name*"
            :state="errors.length > 0 ? false : null"
          >
            <custom-v-select
              v-model="record.oldItemName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="itemOptions"
              label="text"
              placeholder="Select Old Item Name"
              :state="errors.length > 0 ? false:null"
              :reduce="option => option.id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="2">
        <validation-provider
          #default="{ errors }"
          name="Old Item Quantity"
          :vid="`${validationId}_old_item_quantiy`"
          rules="required"
        >
          <b-form-group
            label="Old Item Quantity*"
            :state="errors.length > 0 ? false : null"
          >
            <b-form-input
              v-model="record.oldItemQty"
              :state="errors.length > 0 ? false:null"
              type="number"
              min="0"
              placeholder="Old Item Quantity"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="3">
        <validation-provider
          #default="{ errors }"
          name="New Item Name"
          :vid="`${validationId}_new_item_name`"
          rules="required"
        >
          <b-form-group
            label="New Item Name*"
            :state="errors.length > 0 ? false : null"
          >
            <custom-v-select
              v-model="record.newItemName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="itemOptions"
              label="text"
              placeholder="Select New Item Name"
              :state="errors.length > 0 ? false:null"
              :reduce="option => option.id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="2">
        <validation-provider
          #default="{ errors }"
          name="New Item Quantity"
          :vid="`${validationId}_new_item_quantiy`"
          rules="required"
        >
          <b-form-group
            label="New Item Quantity*"
            :state="errors.length > 0 ? false : null"
          >
            <b-form-input
              v-model="record.newItemQty"
              :state="errors.length > 0 ? false:null"
              type="number"
              min="0"
              placeholder="New Item Quantity"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col md="2">
        <validation-provider
          #default="{ errors }"
          name="Remarks"
          :vid="`${validationId}_remarks`"
          rules=""
        >
          <b-form-group
            label="Remarks"
          >
            <b-form-textarea
              v-model="record.remarks"
              :state="errors.length > 0 ? false:null"
              rows="1"
              placeholder="Remaks"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BFormGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { isEqual, cloneDeep } from 'lodash'

import CustomVSelect from '@/components/UI/CustomVSelect.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    CustomVSelect,
    BFormTextarea,
  },
  props: {
    itemOptions: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    validationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      record: {},
    }
  },
  computed: {
    out() {
      return cloneDeep(this.record)
    },
  },
  watch: {
    out: {
      handler(val) {
        if (!isEqual(val, this.value)) {
          this.$emit('input', val)
        }
      },
      deep: true,
    },
    value: {
      handler(val) {
        if (!isEqual(val, this.out)) {
          this.setInternalState()
        }
      },
      deep: true,
    },
  },
  created() {
    this.setInternalState()
  },
  methods: {
    setInternalState() {
      this.record = cloneDeep(this.value)
    },
  },
}
</script>
